

export class DPModuleConfig {
    product_offering_spec_id: number;
    specification_name: string;
    specification_value: string;
}



// WEBPACK FOOTER //
// ./src/app/portalv1/model/dp-module-config.ts